import React, { useEffect, useState } from 'react'
import { CreateValues, DeleteValues, UpdateProdTiposPerProductoValues, UpdateValues } from '../../../../FormSchemes/ProductoScheme'
import { useDispatch, useSelector } from 'react-redux'
import { requestDefaulAuth } from '../../../../http/httpRequest'
import { UpdateValuesModal } from '../../../../FormSchemes/GeneralFunctions'
import { Section } from '../../../../components/table/Section'
import { ActionSection } from '../../../../components/table/ActionSection'
import { Actions } from '../../../../components/form/actions'
import { ModalForm } from '../../../../components/modals/ModalForm'
import { setReloadMainTable } from '../../../../store/slices/auth/authSlice'
import OilImage from '../../../../assets/oil.png'
import BarrelOil from '../../../../assets/barrelOil.png'

export const ListProductoTable = () => {
    const [data, setData] = useState([])
    const reloadMainTable = useSelector(state => state.login.reloadMainTable)
    const dispatch = useDispatch()
    const lock = useSelector(state => state.login.rol?.limitar_permisos)
    const [generalStates, setGeneralStates] = useState({
        currentData: null,
        createProdForm: false,
        updateProdForm: false,
        updateProdTiposForm: false,
        deleteProdForm: false,
    })
    const getData = async () => {
        await requestDefaulAuth(
            'get',
            `/productos/all`,
            null,
            setData,
            dispatch
        )
    }
    useEffect(() => {
        getData();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [reloadMainTable]);

    return (
        <Section>
            {
                !lock &&
                <ActionSection>
                    <Actions
                        buttons={[
                            {
                                icon: 'add',
                                label: 'Crear',
                                action: () => setGeneralStates(x => ({ ...x, createProdForm: true }))
                            },
                            {
                                icon: 'repeat',
                                label: 'Actualizar',
                                action: () => dispatch(setReloadMainTable())
                            },
                        ]}
                    />
                </ActionSection>
            }
            <div className='grid grid-cols-2 xl:grid-cols-5 gap-2 my-2'>
                {
                    data != null && data?.map((item, index) => (
                        <CardItem
                            key={index}
                            item={item}
                            setCurrentData={(datai) => setGeneralStates(x => ({ ...x, currentData: datai }))}
                            setUpdateModal={(datai) => setGeneralStates(x => ({ ...x, updateProdForm: datai }))}
                            setDeleteModal={(datai) => setGeneralStates(x => ({ ...x, deleteProdForm: datai }))}
                            setProdTiposUpdateModal={(datai) => setGeneralStates(x => ({ ...x, updateProdTiposForm: datai }))}
                            lock={lock}
                        />
                    ))
                }
            </div>
            {
                generalStates.createProdForm &&
                <ModalForm
                    setModal={(datai) => setGeneralStates(x => ({ ...x, createProdForm: datai }))}
                    label={`Crear producto`}
                    dataValues={CreateValues()}
                    urlApi={'/producto'}
                    method={'post'}
                    call={() => dispatch(setReloadMainTable())}
                    buttonLabel='Registrar'
                />
            }
            {
                generalStates.updateProdForm &&
                <ModalForm
                    setModal={(datai) => setGeneralStates(x => ({ ...x, updateProdForm: datai }))}
                    label={`Editar producto ${generalStates.currentData?.nombre}`}
                    dataValues={UpdateValues(generalStates.currentData)}
                    urlApi={'/producto'}
                    method={'put'}
                    call={() => dispatch(setReloadMainTable())}
                    buttonLabel='Editar'
                />
            }
            {
                generalStates.updateProdTiposForm &&
                <ModalForm
                    setModal={(datai) => setGeneralStates(x => ({ ...x, updateProdTiposForm: datai }))}
                    label='Editar precios por tipos de producto'
                    dataValues={UpdateProdTiposPerProductoValues(generalStates.currentData)}
                    urlApi={`/producto/${generalStates.currentData.id}/editProdTipos`}
                    method={'put'}
                    call={() => dispatch(setReloadMainTable())}
                    buttonLabel='Editar'
                    lock={lock}
                />
            }

            {
                generalStates.deleteProdForm &&
                <ModalForm
                    setModal={(datai) => setGeneralStates(x => ({ ...x, deleteProdForm: datai }))}
                    label='Eliminar producto'
                    dataValues={DeleteValues(generalStates.currentData)}
                    urlApi={`/producto/${generalStates.currentData.id}`}
                    method={'delete'}
                    call={() => dispatch(setReloadMainTable())}
                    buttonLabel='Eliminar'
                />
            }
        </Section>
    )
}

const CardItem = ({ item, setCurrentData, setUpdateModal, setDeleteModal, setProdTiposUpdateModal, lock }) => {
    return (
        <div className='text-gray-800 dark:text-white flex flex-col bg-white dark:bg-gray-800 rounded-t-xl justify-between'>
            <div className='flex flex-col'>
                <div className='flex justify-center p-3'>
                    <img src={item.retornable ? BarrelOil : OilImage} alt="box" className='w-24' />
                </div>
                <div className='flex flex-col p-2'>
                    <span className='font-bold text-center text-lg'>{item.nombre}</span>
                    <span className='font-semibold text-center text-sm text-green-600 dark:text-green-500'>{item.retornable ? 'Retornable' : 'No retornable'}</span>
                    <span className='text-sm'>{item.descripcion}</span>
                </div>
                <div className="relative overflow-x-auto p-2">
                    <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
                        <thead className="text-xs text-gray-700 uppercase bg-gray-200 dark:bg-gray-700 dark:text-gray-400">
                            <tr>
                                <th scope="col" className="px-3 py-2 text-end">
                                    Tipo
                                </th>
                                <th scope="col" className="px-3 py-2 text-end">
                                    Precio
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                item.Producto_estados?.map((item, indx) => (
                                    <tr
                                        key={indx}
                                        className="bg-white border-b dark:bg-gray-800 dark:border-gray-700"
                                    >
                                        <th scope="row" className="px-3 py-1 text-end font-semibold text-gray-900 whitespace-nowrap dark:text-white">
                                            {item.tipo}
                                        </th>
                                        <td className="px-3 py-1 text-end">
                                            {item.precio?.toLocaleString('es-BO', { minimumFractionDigits: 2 })}
                                        </td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>
                </div>



            </div>
            {
                !lock &&
                <div className='flex flex-row p-2 justify-end gap-2'>
                    <i className='fa fa-money-bill-1 px-2 py-1 bg-gray-100 dark:bg-gray-900/50 hover:bg-gray-200 hover:dark:bg-gray-700 rounded-md text-lg text-green-500 cursor-pointer' onClick={() => UpdateValuesModal(item, setCurrentData, setProdTiposUpdateModal)} />
                    <>
                        <i className='fa fa-edit px-2 py-1 bg-gray-100 dark:bg-gray-900/50 hover:bg-gray-200 hover:dark:bg-gray-700 rounded-md text-lg text-yellow-500 cursor-pointer' onClick={() => UpdateValuesModal(item, setCurrentData, setUpdateModal)} />
                        <i className='fa fa-trash px-2 py-1 bg-gray-100 dark:bg-gray-900/50 hover:bg-gray-200 hover:dark:bg-gray-700 rounded-md text-lg text-red-500 cursor-pointer' onClick={() => UpdateValuesModal(item, setCurrentData, setDeleteModal)} />
                    </>
                </div>
            }
        </div>
    )
}